import type { CheckoutCalculation } from '../types';

type TenantSettings = Record<string, any> | null | undefined;

export function isTaxEnabled(settings: TenantSettings): boolean {
  return settings?.taxEnabled !== false;
}

export function shouldShowCheckoutTaxSummary(
  calculation: CheckoutCalculation | null,
  settings: TenantSettings
): boolean {
  if (calculation?.taxCalculation) {
    return calculation.taxCalculation.provider !== 'none';
  }

  return isTaxEnabled(settings);
}
